import {TenantInfo} from '../../models/tenant.model';
import {getPlanLevel} from './get-plan-level';

/**
 *
 * These are plan access levels, not plans. Several plans can have the same base access level, but
 * then add specific features for the plan.
 *
 * For example, an AppSumo Special Basic Lifetime Plan, can give access to all Basic features,
 * plus just a couple of Pro features.
 *
 */

const instructorPlanLevelsSortOrder : { [key:string]:number } = {
  "growth": 0, // the Free plan, no premium features, it's like having no plan
  "basic": 1, // basic level, access to some features but not all
  "pro": 2, // pro level, access all platform features
  "enterprise": 3, // enterprise level, access all platform features
  "founder": 4, // special plan no longer used, gives same as Pro plan
  "lifetime": 5 // special plan no longer used, replaced by lifetime-basic and lifetime-pro. lifetime was equivalent to lifetime-pro
};

export function isPlanAllowed(tenant: TenantInfo, minimumPlan:string) {

  const planLevel = getPlanLevel(tenant?.instructorPricingPlan);

  const instructorPlanOrder = instructorPlanLevelsSortOrder[planLevel],
    minimumPlanOrder = instructorPlanLevelsSortOrder[minimumPlan];

  let allowed = (instructorPlanOrder >= minimumPlanOrder);

  return allowed;
}
